// extracted by mini-css-extract-plugin
export default {"modalContainer":"CancelOpeningModal_modalContainer__2PCM3","title":"CancelOpeningModal_title__p2KKq","description":"CancelOpeningModal_description__iuCAh"};